export default __webpack_public_path__ + "static/media/respect.19fb4acc.png";